import React from "react";
import styled from "styled-components";
import { Card } from "storybook-components/Card";

const PostRowCardContainer = styled(Card)`
  padding: 0;
  margin-bottom: 16px;
  min-width: 100%;
  max-width: 100%;
  box-shadow: none;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  &:hover {
    background-color: ${({ theme }) => theme.colors.green4};
    box-shadow: none;
    .text {
      color: ${({ theme }) => theme.colors.green1};
    }
  }
  ${props => props.theme.media.desktopUp`
    margin-right: 1%;
    max-width: calc(100%/3 - 1%);
    min-width: calc(100%/3 - 1%);
    flex: 1;
  `};
`;

export default ({ children }) => (
  <PostRowCardContainer className="PostRowCard">
    {children}
  </PostRowCardContainer>
);
